import {
    FinancialAccount,
    FinancialAccountSourceType,
} from "../types/financialAccount";
import { ConnectionProviderType } from "../types/financialConnection";
import { ConnectionProvider } from "../types/integrationConnection";
import { getLeadingAccountConnection } from "./financialAccount";
import { isPlaidConnection } from "./financialConnection";
import { isIntegrationConnection } from "./integrationConnection";

export enum Processors {
    VENMO = "VENMO",
    PAYPAL = "PAYPAL",
    STRIPE = "STRIPE",
    CASH_APP = "CASH_APP",
}

type ProcessorsConnectedViaPlaid = Exclude<Processors, Processors.STRIPE>;

const processorPlaidBankNames = {
    [Processors.VENMO]: "venmo - personal",
    [Processors.PAYPAL]: "paypal",
    [Processors.CASH_APP]: "cashapp",
} satisfies Record<ProcessorsConnectedViaPlaid, string>;

export function isPaymentProcessorAccount(
    financialAccount: FinancialAccount,
): boolean {
    const connection = getLeadingAccountConnection(financialAccount);

    if (!connection) {
        return false;
    }

    if (isIntegrationConnection(connection)) {
        return connection.provider === ConnectionProvider.PAYPAL;
    } else {
        return (
            connection.connectionProvider === ConnectionProviderType.STRIPE ||
            (isPlaidConnection(connection) &&
                Object.values(processorPlaidBankNames)
                    .map((b) => b.toLowerCase())
                    .includes(connection.bankName.toLowerCase()))
        );
    }
}

export function isSpecificPaymentProcessorAccount(
    financialAccount: FinancialAccount,
    processor: Processors,
): boolean {
    if (
        processor === Processors.PAYPAL &&
        financialAccount.sourceType === FinancialAccountSourceType.PAYPAL
    ) {
        return true;
    }

    const connection = getLeadingAccountConnection(financialAccount);

    if (!connection || isIntegrationConnection(connection)) {
        return false;
    }

    if (processor === Processors.STRIPE) {
        return connection.connectionProvider === ConnectionProviderType.STRIPE;
    }

    if (!isPlaidConnection(connection)) {
        return false;
    }

    return (
        connection.bankName.toLowerCase() ===
        processorPlaidBankNames[processor].toLowerCase()
    );
}
